import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface DuplicateTransitProps {
  transitId: string;
  name: string;
}

export const useDuplicateTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, name }: DuplicateTransitProps): Promise<void> => {
      await request({
        path: 'transits/duplicate',
        method: 'POST',
        authenticate: true,
        dataObject: { transitId, name },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success('Transit duplicated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error duplicating the transit!`);
    },
  });
};
